export const DEFAULT_REQUEST_TIMEOUT = 60 * 1000;

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};

// Configure to include credentials by default (required for HttpOnly cookies)
export const WITH_CREDENTIALS = true;
